<template>
    <div v-bind="$attrs" @click="tryOpenModal" class="app-modal-trigger">
        <img
            src="/default-images/icons/background.png"
            alt="Select Background"
        />
    </div>
    <ModalCustom
        :is-open="state.isBackgroundModalOpen"
        @close="tryCloseLoadModal"
        title="Load Background"
        key="background"
        :z-index="1002"
    >
        <div class="app-modal-dialog">
            <div
                class="app-background-card-empty"
                key="none"
                @click="loadBackground({ name: 'None', image: 'none' })"
            >
                <div class="app-clear-background">CLEAR BACKGROUND</div>
            </div>

            <div
                class="contents"
                v-for="(backgrounds, key) in state.backgrounds"
                :key="key"
            >
                <hr class="w-full" v-if="key != 0" />
                <div
                    class="app-background-card"
                    v-for="background in backgrounds"
                    :key="background.name"
                    @click="loadBackground(background)"
                >
                    <img :src="background.image" :alt="background.name" />
                    <div>
                        {{ background.name }}
                    </div>
                </div>
            </div>
        </div>
    </ModalCustom>
</template>

<script setup>
import { onMounted, reactive, toRaw } from "vue";
import ModalCustom from "./ModalCustom.vue";
import {
    basketballBg,
    footballBg,
    soccerBg,
    hockeyBg,
    fieldHockeyBg,
    lacrosseBg,
    volleyballBg,
} from "./whiteboard/backgrounds";

const state = reactive({
    isBackgroundModalOpen: false,
    currentBackground: props?.background,
    backgrounds: [],
});

async function loadBackground(background) {
    state.isBackgroundModalOpen = false;
    state.currentBackground = background.image;
    const customEvent = new CustomEvent(
        "load-background-modal.background-loaded",
        {
            detail: { background: structuredClone(toRaw(background)) },
        }
    );
    document.dispatchEvent(customEvent);
    emit("loaded", background);
}

const props = defineProps(["sport"]);
const emit = defineEmits(["loaded"]);

const tryCloseLoadModal = () => {
    state.isBackgroundModalOpen = false;
};

function tryOpenModal() {
    state.isBackgroundModalOpen = true;
}

function loadSportBackground() {
    if (props.sport === "basketball") {
        state.backgrounds = [
            basketballBg,
            footballBg,
            soccerBg,
            hockeyBg,
            fieldHockeyBg,
            lacrosseBg,
            volleyballBg,
        ];
    } else {
        state.backgrounds = [
            footballBg,
            basketballBg,
            soccerBg,
            hockeyBg,
            fieldHockeyBg,
            lacrosseBg,
            volleyballBg,
        ];
    }
}

onMounted(() => {
    loadSportBackground();
    window.addEventListener("message", function (event) {
        if (event.data.action === "load_background") {
            loadBackground(event.data);
        }
    });
});
</script>

<style scoped>
.app-modal-dialog {
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
    justify-items: center;
    max-height: 50vh;
    overflow: scroll;
}

.app-background-card-empty {
    text-align: center;
    padding: 16px;
    max-width: 300px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: #f9fafb;
    border: 1px dashed #d1d5db;
    border-radius: 0.375rem;
    cursor: pointer;
}

.app-clear-background {
    padding: 64px;
}

.app-background-card {
    text-align: center;
    padding: 16px;
    max-width: 300px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: #f9fafb;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    cursor: pointer;
}

.app-background-card:hover,
.app-background-card-empty:hover {
    border: 1px solid #3b82f6;
}

.app-modal-trigger {
    cursor: pointer;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    padding: 8px;
    border: 1px solid #d1d5db;
    transition: all 0.2s ease-in-out;
    opacity: 0.5;
}

.app-modal-trigger img {
    width: 100%;
    height: 100%;
}

.app-modal-trigger:hover {
    transform: scale(1.05);
    background-color: #f9fafb;
    opacity: 1;
}
</style>
